import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AlertService } from 'src/app/Common/alert.service';
import { UntypedFormGroup, FormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/shared/common.service';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { DataService } from 'src/app/Common/data.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Global } from 'src/app/Global';
import * as XLSX from 'xlsx';
import saveAs from 'file-saver';

@Component({
  selector: 'app-sub-category',
  templateUrl: './sub-category.component.html',
  styleUrls: ['./sub-category.component.scss'],
  providers: [DataService]
})
export class SubCategoryComponent implements OnInit {
  SubCategoryForm: UntypedFormGroup;
  categoryList: any;
  SubCategoryDataSource: any[];
  viewdata: any;
  statusList: any;
  pageEvent: PageEvent;
  Ispanelshow: any;
  IsAddpanelshow: any;

  displayedColumns = ['CategoryName', 'SubCategoryName', 'Status', 'Edit'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  constructor(private pfb: UntypedFormBuilder, private prouter: Router, private error: AppErrorHandler,
    private activeRoute: ActivatedRoute, public pcommonService: CommonService,
    private status: HTTPStatus, public pdataservice: DataService, public _global: Global, public _com: CommonService) { }

  ngOnInit() {
    //this.paginator.showFirstLastButtons = true;
    this.Ispanelshow = false;
    this.IsAddpanelshow = false;
    //this.paginator.pageSize = this._global.RecordSize;
    this.SubCategoryForm = this.pfb.group({
      RequestEntityId: [''],
      SelectedCategory: ['', [Validators.required]],
      CategoryName: [],
      SubCategoryId: [''],
      SubCategoryName: ['', [Validators.required]],
      IsActive: [''],
      PageNumber: (this._global.pageIndex),
      PageSize: (this._global.RecordSize),
      StatusSearch: [''],
      CategorySearch: [''],
      CategoryId: [''],


    });

    this.BindCategoryList();
    this.SearchRecord();
    this.BindStatusList();
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.pageSize = this._global.RecordSize;
      this.paginator.showFirstLastButtons = true;
    }
  }
  SearchRecord() {

    this._global.pageIndex = 0;
    this._global.length = 0;
    this._global.totalPage = 0;
    this._global.RecordSize = 10;
    this.ViewSubCategoryList();
  }

  ViewSubCategoryList() {

    this.SubCategoryForm.controls.PageNumber.setValue(this._global.pageIndex + 1);
    this.SubCategoryForm.controls.PageSize.setValue(this._global.RecordSize);
    this.SubCategoryForm.patchValue({
      CategoryId: this.SubCategoryForm.controls.CategorySearch.value.value,
      IsActive: this.SubCategoryForm.controls.StatusSearch.value.StatusId,
    });
    this.pdataservice.PostData('Category/GetSubCategoryForView/', this.SubCategoryForm.value).subscribe(result => {
      this.viewdata = result;

      if (this.viewdata != null && this.viewdata.length > 0) {
        this.SubCategoryDataSource = this.viewdata;


        this._global.length = this.viewdata[0].totalrecordcount;
        this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);

      } else {
        this.SubCategoryDataSource = this.viewdata;
        this._global.length = 0;
        this.paginator.pageSize = this._global.RecordSize;
        this._global.pageIndex = 0;
        this._global.totalPage = 0;
      }
    });
  }

  onPaginateChange1(event) {
    this._global.pageIndex = event.pageIndex;
    this._global.RecordSize = event.pageSize;
    this.ViewSubCategoryList();
  }

  rowclickdata(row: any) {

    var dataitem;
    dataitem = this.SubCategoryDataSource.filter(x => x.SubCategoryId == row);
    this.SubCategoryForm.patchValue({
      SubCategoryId: dataitem[0]['SubCategoryId'],
      SubCategoryName: dataitem[0]['SubCategoryName'],
      SelectedCategory: this.BindSpecialization(dataitem[0]['CategoryName']),
      IsActive: dataitem[0]['IsActive']
    });
  }

  BindSpecialization(sf) {

    let p = this.categoryList.filter(x => x.label == sf);
    return p[0];
  }

  BindCategoryList() {

    this.pcommonService.BindDropDown('CategoryWithRole').subscribe(result => {
      this.categoryList = result;
    });
  }

  showErrorsOnInvalidForm() {
    Object.keys(this.SubCategoryForm.controls).forEach(field => {
      const control = this.SubCategoryForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  GetFormControls(controlName) {
    return this.SubCategoryForm.controls[controlName];
  }


  submitdata() {
    this.GetFormControls('SelectedCategory').setValidators([Validators.required]);
    this.GetFormControls('SelectedCategory').updateValueAndValidity();
    this.GetFormControls('SubCategoryName').setValidators([Validators.required]);
    this.GetFormControls('SubCategoryName').updateValueAndValidity();
    if (!this.SubCategoryForm.valid) {
      alert('Please fill mandatory fields.');
      this.showErrorsOnInvalidForm();

      return false;
    }
    this.status.setHttpStatus(true);
    this.pdataservice.PostData('Category/SaveSubCategory/', this.SubCategoryForm.value).subscribe(result => {
      alert(result[0].MSG);
      if (result[0].STATUS == 0) {
        this.cleardata();
        this.ViewSubCategoryList();
        this.GetFormControls('SelectedCategory').clearValidators();
        this.GetFormControls('SelectedCategory').updateValueAndValidity();
        this.GetFormControls('SubCategoryName').clearValidators();
        this.GetFormControls('SubCategoryName').updateValueAndValidity();
      }

    }
      , (error) => {
        this.status.setHttpStatus(false);
        this.error.handleError(error);
      },
      () => { this.status.setHttpStatus(false); });
  }

  cleardata() {
    this.SubCategoryForm.controls.SelectedCategory.setValue('');
    this.SubCategoryForm.controls.SubCategoryName.setValue('');
    this.SubCategoryForm.controls.IsActive.setValue('');
    this.SubCategoryForm.patchValue({
      SubCategoryId: 0
    });
  }

  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'Subcategory.xlsx');

  }

  Export() {
    this.status.setHttpStatus(true);
    this._com.ExportToExcelSubCategory(this.SubCategoryForm.value).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, 'SubCategory_Master.xls');
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

  ResetData() {

    this.SubCategoryForm.reset({
      "CategorySearch": "",
      "StatusSearch": ""
    })
    this.GetResult();

  }

  Exit() {

    if (this.SubCategoryForm.valid) {
      if (confirm("Are you sure you want to exit without saving changes?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
      }
    } else {
      if (confirm("Are you sure to exit?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
      }
    }

  }

  BindStatusList() {
    this.pdataservice.GetData('Category/GetStatus/').subscribe(result => {

      this.statusList = result;
      debugger;
    });
  }

  GetResult() {

    this.SearchRecord();


  }

  showhide() {
    this.Ispanelshow = !this.Ispanelshow;

  }

  showhideAdd() {
    this.IsAddpanelshow = !this.IsAddpanelshow;

  }

}
